import { MeasurementsLayer } from "./MeasurementsLayer.js";
import { StaLoader } from "../../data/StaLoader.js";

export { StaLayer }

/**
 * Layer for displaying Data from an STA-Endpoint in the viewer
 * 
 * @author rhess <robin.hess@awi.de>
 * @memberof vef.map.layer
 */
class StaLayer extends MeasurementsLayer {

    /**
     * Set all properties for the layer based on the options object.
     * 
     * @param {object} config 
     * @param {object} cache 
     * @param {string} id 
     */
    constructor(config, cache, id) {
        // calling parent constructor
        super(config, cache, id);

        // init default values and define getters and setters
        this.addDefaults_({
            // overwrite defaults
            defaultXAxis: "datetime",
            defaultYAxis: this.columnData,
            columnLatitude: null,
            columnLongitude: null,
            limit: 10000,
            url: null,
            title: "[STA Layer] " + (config.url || cache.url || ""),
            // STA Metadata
            staMetadata: {}
        });

        this.setAll_("type", "sta");

        this.staLoader_ = new StaLoader(this.url);

        this.fetchMetadata_();
    }

    async fetchMetadata_() {
        const response = await fetch(`${this.url}/Datastreams(${this.columnData})?$expand=Thing($expand=Locations),Sensor,ObservedProperty`);

        this.cache.staMetadata = await response.json();
        this.cache.title = this.cache.staMetadata.name;
        this.cache.abstract = this.cache.staMetadata.description;

        if (this.cache.staMetadata?.observedArea) {
            this.cache.position = this.cache.staMetadata.observedArea;
        } else if (this.cache.staMetadata?.Thing?.Locations) {
            this.cache.position = [];
            this.cache.staMetadata.Thing.Locations.forEach(location => {
                if (location.location) {
                    this.cache.position.push(location.location);
                }
            });
        }

        this.fire("update", this);
    }

    /**
     * Loads data of the dws filtered by time
     * @private
     */
    applyFilter_() {
        let beginDate, endDate;

        for (let i = 0; i < this.filter.length; ++i) {
            if ((this.filter[i].type == "time") && (this.filter[i].values.length > 0)) {
                const values = this.filter[i].values[0];
                if ((values.length == 3) && (values[0] == "bt")) {
                    beginDate = values[1].substr(0, 19);
                    endDate = values[2].substr(0, 19);
                }
            }
        }

        const columns = [this.columnData];
        if (this.columnLatitude && this.columnLongitude) columns.push(this.columnLatitude, this.columnLongitude);

        return new Promise(resolve => {
            this.staLoader_.data(columns, {
                beginDate: beginDate,
                endDate: endDate,
                limit: this.limit
            }).then(df => {
                this.dataFrameOriginal = df;
                this.dataFrame = df;
                resolve(df);
            });
        });
    }

}